import clsx from 'clsx';

export const gridGapClasses = clsx`gap-x-16 md:gap-x-24`;

export const fullScreenGridClasses = clsx(gridGapClasses, 'grid w-full grid-cols-root md:grid-cols-root-md');

export const fullScreenChildGridClasses = clsx(fullScreenGridClasses, 'col-span-full');

export const centeredFooterGridClasses = clsx(
  gridGapClasses,
  'col-span-6 col-start-2 grid grid-cols-6 md:col-span-12 md:col-start-2 md:grid-cols-12'
);

export const centeredMainGridClasses = clsx(
  gridGapClasses,
  'col-span-6 col-start-1 grid grid-cols-6 md:col-span-12 md:col-start-1 md:grid-cols-12'
);

export const centeredMainChildGridClasses = clsx(gridGapClasses, 'col-span-full grid grid-cols-6 md:grid-cols-12');
